var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Content"
  }, [_c('preloader', {
    attrs: {
      "show": _vm.show
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img bcg-img",
    style: ({
      backgroundPositionX: _vm.pos + '%'
    })
  }, [_c('div', {
    staticClass: "nav-block",
    class: {
      showNav: _vm.show
    }
  }, [_c('a', {
    class: {
      active: _vm.isActive(1)
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.posfunc(1)
      }
    }
  }, [_vm._v("Company")]), _vm._v(" "), _c('a', {
    class: {
      active: _vm.isActive(2)
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.posfunc(2)
      }
    }
  }, [_vm._v("Freestyle")]), _vm._v(" "), _c('a', {
    class: {
      active: _vm.isActive(3)
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.posfunc(3)
      }
    }
  }, [_vm._v("Freeride")]), _vm._v(" "), _c('a', {
    class: {
      active: _vm.isActive(4)
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.posfunc(4)
      }
    }
  }, [_vm._v("Universal")]), _vm._v(" "), _c('a', {
    class: {
      active: _vm.isActive(5)
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.posfunc(5)
      }
    }
  }, [_vm._v("Contacts")]), _vm._v(" "), _c('a', {
    class: {
      active: _vm.isActive(6)
    },
    attrs: {
      "href": "https://en.phantom.equipment"
    }
  }, [_vm._v("ENG")])]), _vm._v(" "), _c('Logo', {
    attrs: {
      "show": _vm.show,
      "active": _vm.activeItem
    }
  })], 1), _vm._v(" "), _c('img', {
    staticClass: "blur",
    class: {
      showBlur: _vm.isBlur(2)
    },
    attrs: {
      "src": require("../assets/blur.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "blur",
    class: {
      showBlur: _vm.isBlur(3)
    },
    attrs: {
      "src": require("../assets/blur.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "blur",
    class: {
      showBlur: _vm.isBlur(4)
    },
    attrs: {
      "src": require("../assets/blur.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mainContent",
    class: {
      display: _vm.displayMain()
    }
  }, [_c('leftBlock', {
    attrs: {
      "active": _vm.activeItem
    }
  }), _vm._v(" "), _c('board', {
    attrs: {
      "active": _vm.activeItem
    }
  }), _vm._v(" "), _c('rightBlock', {
    attrs: {
      "active": _vm.activeItem
    }
  }), _vm._v(" "), _c('blackLogo', {
    staticClass: "logo-black",
    attrs: {
      "active": _vm.activeItem
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-wrapper",
    staticStyle: {
      "margin": "90px auto 0"
    }
  }, [(_vm.isActive(2)) ? [_c('h3', {
    staticClass: "mainPage-text text-header"
  }, [_vm._v("Freestyle")]), _vm._v(" "), _c('p', {
    staticClass: "mainPage-text mainPage-bottom text-content"
  }, [_vm._v("Phantom T — машина для бэккантти-фристайла, на которой можно уверенно прыгать как с пушистых дропов, так и в парке. Классический кембер в сочетании с умеренными рокерами на носу и хвосте, позволяет этому твин-типу иметь отличную отдачу на жестком склоне и всплывать в пухляке. Спеченый скользяк с финишной обработкой и базовым парафином, деревянный сердечник из ясеня и липы, карбоновые стрингеры, шнуровка кантов кевларом KEEN System и эпоксидная смола Carbon AERO.")])] : _vm._e(), _vm._v(" "), (_vm.isActive(3)) ? [_c('h3', {
    staticClass: "mainPage-text text-header"
  }, [_vm._v("Freeride")]), _vm._v(" "), _c('p', {
    staticClass: "mainPage-text mainPage-bottom text-content"
  }, [_vm._v("Phantom F – истребитель снежных пространств последнего поколения. Жесткий, быстрый и маневренный он не потопляем в глубоком снегу и режет, как масло, леденистые склоны. Спеченый скользяк с финишной обработкой и базовым парафином, деревянный сердечник из ясеня и липы, карбоновые стрингеры, шнуровка кантов кевларом KEEN System и эпоксидная смола Carbon AERO.")])] : _vm._e(), _vm._v(" "), (_vm.isActive(4)) ? [_c('h3', {
    staticClass: "mainPage-text text-header"
  }, [_vm._v("Universal")]), _vm._v(" "), _c('p', {
    staticClass: "mainPage-text mainPage-bottom text-content"
  }, [_vm._v("Phantom U – многоцелевая машина, способная раскрыть возможности самого опытного пилота. Жесткая трасса, глубокий снег, гигантские дропы — на него можно положиться в любых условиях. Спеченый скользяк с финишной обработкой и базовым парафином, деревянный сердечник из ясеня и липы, карбоновые стрингеры, шнуровка кантов кевларом KEEN System и эпоксидная смола Carbon AERO.")])] : _vm._e()], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "mainPage",
    class: {
      displayMain: _vm.displayMainPage()
    }
  }, [_c('p', {
    staticClass: "mainPage-text mainPage-header"
  }, [_vm._v("COMPANY")]), _vm._v(" "), _c('p', {
    staticClass: "mainPage-text"
  }, [_vm._v("Путь к совершенству лежит через преодоление невозможного")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "mainPage-text"
  }, [_vm._v("Вчера мы осваивали технологии известных производителей, чтобы создать сноуборды\n\t\t\t\tмирового уровня — сегодня мы используем собственные технологии и подходы, чтобы\n\t\t\t\tбыть на высоте. Мы создали Phantom — точный инструмент, оставляющий безупречный\n\t\t\t\tслед на любом рельефе. Спроектированные инженерами и учёными Новосибирского\n\t\t\t\tакадемгородка, собранные профессионалами из лучших материалов, сноуборды Phantom\n\t\t\t\tготовы раскрыть твой потенциал на 100%.")]), _vm._v(" "), _c('p', {
    staticClass: "mainPage-text mainPage-header"
  }, [_vm._v("Carbon AERO")]), _vm._v(" "), _c('p', {
    staticClass: "mainPage-text mainPage-subheader"
  }, [_vm._v("Carbon Alloy Epoxy Resin")]), _vm._v(" "), _c('p', {
    staticClass: "mainPage-text"
  }, [_vm._v("Изгибы, удары и вибрации медленно разрушают материалы изнутри. Чтобы Phantom\n\t\t\t\tслужил дольше и был твоим надёжным напарником в самых экстремальных условиях,\n\t\t\t\tмы используем эпоксидную смолу, обогащенную углеродными нанотрубками.\n\t\t\t\tВстраиваясь в полимерную матрицу смолы, нанотрубки препятствуют росту\n\t\t\t\tмикротрещин, что делает конструкцию долговечнее. Эту задачу мы решили в\n\t\t\t\tсотрудничестве с OCSiAl, мировым лидером производства углеродных нанотрубок.\n\t\t\t\tCarbon AERO — новый уровень композитных систем.")]), _vm._v(" "), _c('p', {
    staticClass: "mainPage-text mainPage-header"
  }, [_vm._v("KEEN System")]), _vm._v(" "), _c('p', {
    staticClass: "mainPage-text mainPage-subheader"
  }, [_vm._v("Kevlar Edge ENhancement System")]), _vm._v(" "), _c('p', {
    staticClass: "mainPage-text mainPage-bottom"
  }, [_vm._v("Мягкий белоснежный склон нередко скрывает острые камни, которые могут испортить\n\t\t\t\tтвоё снаряжение. Сноуборд с вырванным кантом чаще всего отправляется на свалку.\n\t\t\t\tЧтобы твой отдых не омрачил досадный случай, мы связываем стальные канты по всей их\n\t\t\t\tдлине прочными кевларовыми нитями. KEEN System — твоя уверенность в каждой дуге.")]), _vm._v(" "), _c('blackLogo', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }), _vm._v(" "), _vm._m(0)], 1), _vm._v(" "), (_vm.isActive(5)) ? _c('div', {
    staticClass: "contact"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p', {
    staticClass: "mainPage-text"
  }, [_vm._v("ООО «Техноресурс»")]), _vm._v(" "), _c('p', {
    staticClass: "mainPage-text"
  }, [_vm._v("Юридический адрес: 630090, г. Новосибирск, ул. Инженерная, 16")]), _vm._v(" "), _c('p', {
    staticClass: "mainPage-text"
  }, [_vm._v("Почтовый адрес: 630090, г. Новосибирск, ул. Инженерная, 16")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('p', {
    staticClass: "mainPage-text"
  }, [_vm._v("ИНН: 5408283940")]), _vm._v(" "), _c('p', {
    staticClass: "mainPage-text"
  }, [_vm._v("КПП: 540801001")]), _vm._v(" "), _c('p', {
    staticClass: "mainPage-text"
  }, [_vm._v("ОГРН: 1105476084526")]), _vm._v(" "), _c('p', {
    staticClass: "mainPage-text"
  }, [_vm._v("р/с: 40702810502020050096 В ПАО Банка «ФК ОТКРЫТИЕ»")]), _vm._v(" "), _c('p', {
    staticClass: "mainPage-text"
  }, [_vm._v("к/сч: 30101810100000000867")]), _vm._v(" "), _c('p', {
    staticClass: "mainPage-text"
  }, [_vm._v("БИК: 04500486")]), _vm._v(" "), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('blackLogo', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('p')], 1) : _vm._e(), _vm._v(" "), _c('footerComponent')], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "mainPage-text mainPage-subheader"
  }, [_c('a', {
    staticClass: "mainPage-link",
    attrs: {
      "href": "https://fasie.ru/"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/f.jpg"),
      "width": "180",
      "height": "120"
    }
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "mainPage-text"
  }, [_c('a', {
    staticClass: "mainPage-link",
    attrs: {
      "href": "mailto:hi@phantom.equipment"
    }
  }, [_vm._v("hi@phantom.equipment")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "mainPage-text"
  }, [_c('a', {
    staticClass: "mainPage-link",
    attrs: {
      "href": "mailto:sales@phantom.equipment"
    }
  }, [_vm._v("sales@phantom.equipment")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "mainPage-text"
  }, [_vm._v("Тел: \n\t\t\t\t"), _c('a', {
    staticClass: "mainPage-link",
    attrs: {
      "href": "tel:+79139274951"
    }
  }, [_vm._v("+7 913 927-49-51")]), _vm._v(",\n\t\t\t\t"), _c('a', {
    staticClass: "mainPage-link",
    attrs: {
      "href": "tel:+79232226828"
    }
  }, [_vm._v("+7 923 222-68-28")]), _vm._v(",\n\t\t\t")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "mainPage-text mainPage-subheader"
  }, [_c('a', {
    staticClass: "mainPage-link",
    attrs: {
      "href": "https://fasie.ru/"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/f.jpg"),
      "width": "180",
      "height": "120"
    }
  })])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-09227c25","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Content.vue
// module id = QSgK
// module chunks = 0